import { render, staticRenderFns } from "./CookiesSnackbar.vue?vue&type=template&id=739f3f9c&scoped=true&lang=pug&"
import script from "./CookiesSnackbar.vue?vue&type=script&lang=js&"
export * from "./CookiesSnackbar.vue?vue&type=script&lang=js&"
import style0 from "./CookiesSnackbar.vue?vue&type=style&index=0&id=739f3f9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739f3f9c",
  null
  
)

export default component.exports